//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TransitionExpand from "./global/TransitionExpand";
import FilterKey from "./FilterKey";

const openFilter = {};

export default {
  props: {
    showContentType: {
      type: Boolean,
    },
    showCategories: {
      type: Boolean,
    },
    filterGroups: {
      type: Array,
    }
  },
  components: {
    appTransitionExpand: TransitionExpand,
    FilterKey,
  },
  data: function () {
    return {
      loaded: false,
      mobileOpen: false,
      filterState: [],
			singleSelectFilterIds: [],
			queryIds: null
    };
  },
  watch: {
    filters() {
      if (!this.loaded && this.$route.query.c && this.filters.length > 0) {
        var f = JSON.parse(JSON.stringify(this.filters));
        this.updateFiltersFromQuerystring(this.$route.query.c, f);

        this.$emit("submitFilters", f);
        this.loaded = true;
      }
    },
  },
  computed: {
    filters: function () {
      return this.$store.state.results.filters;
    },
    settings: function () {
      return this.$store.state.settings;
    },
    visibleFilters: function () {
      let tempFilters = this.$props.showContentType
        ? this.filters.filter((f) => f.visible == true)
        : this.filters.filter(
            (f) => f.visible == true && f.id != "search_contenttype"
          );
      return this.$props.showCategories
        ? tempFilters
        : tempFilters.filter((f) => f.id == "search_contenttype");
    },
    allowedFilters: function () {
      return this.$props.filterGroups;
    },
    hasFilters: function () {
      return {
        results: this.$store.state.searchQuery.filters.some((f) => f.filters.some((fn) => fn.selected)),
        selected: this.visibleFilters.some((f) => f.filters.some((fn) => fn.selected)),
      }
    },
  },
  methods: {
    goTo(id) {
      const dest = document.querySelector(id);
      const focusable = 'a, button, input, select, textarea, [tabindex]:not([tabindex*="-"])';

      if (dest.matches(focusable)) {
        dest.focus();
      }
      else {
        dest.querySelector(focusable).focus();
      }
    },
		returnValidIdVal(id) {
			return id.replace(/[^a-zA-Z0-9]/g, '');
		},
    toggleFilter(e, i) {
      e.stopPropagation();
      
      const filterState = [...this.filterState];

      if (i >= 0) {
        const newVal = !filterState[i];
        if (this.settings.horizontalFilters)
          filterState.fill(false);
        filterState[i] = newVal;
      }

      if(filterState[i]) {
        openFilter.index = i;
        openFilter.parent = e.target.parentElement;
        if (!openFilter.interval)
          openFilter.interval = requestAnimationFrame(checkFilterOffscreen);
      }
      else {
        openFilter.index = null;
        openFilter.parent = null;
        cancelAnimationFrame(openFilter.interval);
        openFilter.interval = null;
      }

      this.filterState = filterState;
    },
    submitFilters: function () {
      this.$emit("submitFilters", this.filters);
    },
		checkForSingleSelect: function(itemId, groupId) {
			let isSingleSelect = this.singleSelectFilterIds.includes(groupId);
			let checkEl = this.$el.querySelector(`#filter-${this.returnValidIdVal(itemId)}`);
			if (!checkEl) return;
			let isChecked = checkEl.checked;
			let filterGroupElement = this.$el.querySelector(`#group-${this.returnValidIdVal(groupId)}`);
			let filterElements = [...filterGroupElement.querySelectorAll(".filters__input")];
			if (!!isSingleSelect && isChecked) {
				filterElements.forEach((filterElement) => {
					if (filterElement.id != "filter-" + this.returnValidIdVal(itemId)) {
						filterElement.checked = false;
						filterElement.disabled = true;
					}
				});
			} else if (!isChecked) {
				filterElements.forEach((filterElement) => {
					filterElement.disabled = false;
				});
			}
			if (!this.settings.showFilterButton) this.submitFilters();
		},
    updateFiltersFromQuerystring(query, filters) {
      this.queryIds = query.split(",");

      this.queryIds.forEach(function (theID) {
        filters.forEach(function (parent) {
          var match = parent.filters.find((c) => c.id === theID);

          if (match) {
            match.selected = true;
          }
        });
      });
    },
    getFilterText: function (filter) {
      return filter.value;
    },
    clearFilters: function () {
      this.filters.forEach((group) => {
        group.filters.forEach((filter) => {
          filter.selected = false;
        });
      });
      this.filterState = this.filterState.fill(false);
      this.submitFilters();
    },
    selectedCountInGroup: function (group) {
      return group.filters.reduce((acc, filter) => filter.selected ? acc + 1 : acc, 0);
    },
    checkCloseDropdown: function(e) {
      if (e.type === 'click' && e.srcElement.closest('.filters__group')) return;
      else if (e.type === 'keydown' && e.key !== 'Escape') return;
      this.filterState = [...this.filterState.fill(false)];
    },
  },
  created() {
		this.singleSelectFilterIds = this.$root.singleSelectFilters.split(",");
		var query = this.$route.query.c;
		this.queryIds = query ? query.split(",") : [];
		var changed = false;
		this.filters.forEach((group) => {
			group.filters.forEach((filter) => {
				if (this.queryIds.includes(filter.id) && !filter.selected) {
					filter.selected = true;
					changed = true;
				}
			});
		});
		if (changed) {
			this.submitFilters();
		}
  },
  mounted() {
    let filterState = [];
    this.filters.forEach((filterGroup, i) => {
      filterState.push(i === 0 && !this.$store.state.settings.horizontalFilters);
    });
    this.filterState = filterState;

    document.addEventListener("click", this.checkCloseDropdown);
    window.addEventListener("keydown", this.checkCloseDropdown);

		
		this.filters.forEach((group) => {
			group.filters.forEach((filter) => {
				if (this.queryIds.includes(filter.id)) {
					this.checkForSingleSelect(filter.id, group.id);
				}
			});
		});
  },
  beforeDestroy: function () {
    this.filterState = [];

    document.removeEventListener("click", this.checkCloseDropdown);
    document.removeEventListener("keydown", this.checkCloseDropdown);
  },
};

function checkFilterOffscreen() {
  if (!(openFilter.index + 1) || !openFilter.parent) return;

  const options = openFilter.parent.querySelector(".filters__options");
  if (!options) return;

  const rect = options.getBoundingClientRect();
  if (rect.right > window.innerWidth - 30)
    options.classList.add("align-right");

  requestAnimationFrame(checkFilterOffscreen);
}
